// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgSubtractLine = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="M5 11h14v2H5z" />
  </svg>
);
export const SubtractLineIcon = forwardRef(SvgSubtractLine);
